import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  closeModal,
  deleteCategory,
} from "../../../feature/category/categorySlice";
import UpdateCategoryForm from "../../forms/UpdateCategoryForm";

const CategoryModals = () => {
  const dispatch = useDispatch();
  const {
    isViewModalOpen,
    isDeleteModalOpen,
    viewSingleCategory,
    isEditModalOpen,
  } = useSelector((state) => state.categories);

  const ViewCategoryModal = () => {
    return (
      <Dialog open={isViewModalOpen} onClose={() => dispatch(closeModal())}>
        <DialogTitle> {viewSingleCategory.id} </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            ID: {viewSingleCategory.id}
          </DialogContentText>
          <DialogContentText id='alert-dialog-description'>
            CATEGORY: {viewSingleCategory.category_name}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color='secondary'
            onClick={() => dispatch(closeModal())}
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const DeleteConfirmationModal = () => {
    return (
      <Dialog open={isDeleteModalOpen}>
        <DialogTitle>Delete {viewSingleCategory.category_name} </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Are you sure you want to delete this User?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color='error'
            onClick={() => {
              dispatch(deleteCategory(viewSingleCategory.id));
            }}
          >
            Delete
          </Button>
          <Button color='secondary' onClick={() => dispatch(closeModal())}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const EditCategoryModal = () => {
    return (
      <Dialog open={isEditModalOpen} onClose={() => dispatch(closeModal())}>
        <DialogTitle> {viewSingleCategory.id} </DialogTitle>
        <Divider />
        <DialogContent>
          <UpdateCategoryForm
            id={viewSingleCategory.id}
            category_name={viewSingleCategory.category_name}
          />
        </DialogContent>
        {/* <DialogActions>
          <Button
            color='secondary'
            onClick={() => dispatch(closeModal())}
            autoFocus
          >
            OK
          </Button>
        </DialogActions> */}
      </Dialog>
    );
  };

  return (
    <>
      <ViewCategoryModal />
      <DeleteConfirmationModal />
      <EditCategoryModal />
    </>
  );
};

export default CategoryModals;
